import { ColorLensOutlined } from '@mui/icons-material'

interface IColorByValueDropdownToggleButton {
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

const Button = ({ onClick }: IColorByValueDropdownToggleButton) => {
  return (
    <button className='flex' onClick={onClick} type='button'>
      <ColorLensOutlined />
      <div className='ml-2'>Color by Value</div>
    </button>
  )
}

export default Button
